import React from 'react'

export default function Signers() {
  return (
    <>
      <div id="signers_zone"></div>
    </>
  )
}
